export default {
  properties: {
    display_name: {
      type: 'string',
      description:
        "display name of the Product ; eg : Levi's Men 501 Blue Jeans"
    },
    gtin: { type: 'string', description: 'contains gtin, ean or upc' },
    mpn: {
      type: 'string',
      description: 'mpn, manufacturer part number (internal id of the product)'
    },
    parent_code: { type: 'string', description: 'parent id/code' },
    category: { type: 'string', description: 'product category' },
    sub_category: { type: 'string', description: 'subcategory' },
    gender: { type: 'string', description: 'gender' },
    review: { type: 'string', description: 'review' },
    retailer_link: {
      type: 'string',
      description: 'link to product page at retailers website'
    },
    image_links: {
      items: { type: 'string' },
      type: 'array',
      description: 'image link'
    },
    regular_price: { type: 'string', description: 'product regular_price' },
    sale_price: {
      type: 'string',
      description: 'product sales price with currency'
    },
    description: { type: 'string', description: 'product description' },
    color: { type: 'string', description: 'product color' },
    size: { type: 'string', description: 'product size' },
    material: { type: 'string', description: 'product material' },
    weather: { type: 'string', description: 'product weather' },
    fit: { type: 'string', description: 'product fit' },
    occasion: { type: 'string', description: 'product occasion' },
    style: { type: 'string', description: 'product style' },
    temporality: { type: 'string', description: 'Product temporality' },
    season: { type: 'string', description: 'product season' },
    age_group: { type: 'string', description: 'product age group' },
    price_range: { type: 'string', description: 'product price range' },
    review_count: { type: 'integer', description: 'review count' },
    vat: { type: 'number', description: 'vat' },
    ecotax: { type: 'number', description: 'ecotax' }
  },
  additionalProperties: false,
  type: 'object',
  title: 'Product',
  description: 'Products',
  required: []
};
